<script setup>
import moment from "moment";
import { TableCell } from "@easy/ui/tables";
import { AvatarSm } from "@easy/ui/avatars";
import { LinkShareIcon } from "@easy/ui/icons";
import { useRoute } from "vue-router";
import { computed } from "vue";

const { params } = useRoute();
const playerUUID = computed(() => params.projectUuid);

const props = defineProps({
    certificate: {
        type: Object,
        required: true,
    },
});

const issueDate = computed(() => moment(props.certificate.issueDate).format("DD.MM.YYYY"));
</script>

<template>
    <tr class="cursor-pointer" @click="$emit('select')">
        <TableCell truncate>
            <div class="flex">
                <div class="hidden lg:block mr-3">
                    <AvatarSm image="" :name="certificate.fullName" />
                </div>
                <div class="overflow-hidden">
                    <p class="font-medium truncate">{{ certificate.fullName }}</p>
                    <p class="ct-text-3 truncate">{{ certificate?.student?.email }}</p>
                </div>
            </div>
        </TableCell>
        <TableCell sm-hidden>
            <p class="ct-text-3">{{ certificate.uuid }}</p>
        </TableCell>

        <TableCell sm-hidden>
            <p class="ct-text-3">{{ issueDate }}</p>
        </TableCell>
        <TableCell sm-hidden>
            <a
                :href="`/players/${playerUUID}/certificates/${certificate.uuid}`"
                @click.stop="() => {}"
            >
                <LinkShareIcon />
            </a>
        </TableCell>
    </tr>
</template>
